<template>

  <inventory-calendar-popup title="Entire Location (including PARCS)">

    <div class="d-flex justify-space-between">
      <div>
        {{ Temporal.PlainDateTime.from(item.start).toPlainTime().toLocaleString(undefined, {timeStyle: 'short'}) }} –
        {{ Temporal.PlainDateTime.from(item.end).toPlainTime().toLocaleString(undefined, {timeStyle: 'short'}) }}
      </div>
      <div class="text-end">
        {{ item.spacesSold }}/{{ item.spacesTotal }}
      </div>
    </div>

  </inventory-calendar-popup>

</template>

<script setup lang="ts">

// components
import InventoryCalendarPopup from './InventoryCalendarPopup.vue'
import type { DaySummaryWithParcsInventoryCalendarItem } from '../calendarItemTypes'

// models
interface Props {
  item: DaySummaryWithParcsInventoryCalendarItem
}

// misc
import { Temporal } from '@js-temporal/polyfill'

defineProps<Props>()

</script>
